/* THIS IS TAMIL™ — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';

  var theme = window.theme || {};
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); }; }
  function storage(key, value) {
    try {
      if (value === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) { return null; }
  }

  /* ------------------------------------------------------------------
     Overlays: drawers, menu, search (shared open/close + focus trap)
  ------------------------------------------------------------------ */
  var Overlay = {
    active: null,
    trigger: null,
    open: function (el, trigger) {
      if (!el) return;
      if (this.active && this.active !== el) this.close(true);
      this.active = el;
      this.trigger = trigger || document.activeElement;
      el.hidden = false;
      document.body.classList.add('is-locked');
      $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.add('is-open');
          var focusTarget = el.querySelector('[data-predictive-input]') || el.querySelector('[data-menu-close], [data-drawer-close]') || el.querySelector(FOCUSABLE);
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        });
      });
    },
    close: function (instant) {
      var el = this.active;
      if (!el) return;
      el.classList.remove('is-open');
      $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var done = function () { if (!el.classList.contains('is-open')) el.hidden = true; };
      if (instant || reducedMotion) done(); else setTimeout(done, 450);
      document.body.classList.remove('is-locked');
      if (this.trigger && this.trigger.focus && !instant) this.trigger.focus({ preventScroll: true });
      this.active = null;
    }
  };

  document.addEventListener('keydown', function (e) {
    if (!Overlay.active) return;
    if (e.key === 'Escape') { Overlay.close(); return; }
    if (e.key === 'Tab') {
      var f = $$(FOCUSABLE, Overlay.active).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener;
    if ((opener = t.closest('[data-menu-open]'))) { Overlay.open($('[data-menu-drawer]'), opener); return; }
    if ((opener = t.closest('[data-search-open]'))) { Overlay.open($('[data-search-overlay]'), opener); return; }
    if ((opener = t.closest('[data-drawer-open]'))) { Overlay.open(document.getElementById(opener.getAttribute('data-drawer-open')), opener); return; }
    if ((opener = t.closest('[data-cart-open]'))) {
      var drawer = $('[data-cart-drawer]');
      if (drawer && theme.cartType === 'drawer') { e.preventDefault(); Overlay.open(drawer, opener); }
      return;
    }
    if (t.closest('[data-menu-close], [data-search-close], [data-drawer-close]')) { Overlay.close(); return; }
    // click on drawer backdrop
    if (Overlay.active && t === Overlay.active && Overlay.active.hasAttribute('data-drawer')) Overlay.close();
  });

  /* ------------------------------------------------------------------
     Header: scrolled state
  ------------------------------------------------------------------ */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------------
     Cart (AJAX + Section Rendering API)
  ------------------------------------------------------------------ */
  var Cart = {
    sectionId: 'cart-drawer',
    request: function (url, body) {
      var drawer = $('[data-cart-drawer]');
      if (drawer) {
        body.sections = [this.sectionId];
        body.sections_url = window.location.pathname;
        drawer.classList.add('is-loading');
      }
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
        .finally(function () { if (drawer) drawer.classList.remove('is-loading'); });
    },
    render: function (sections) {
      if (!sections || !sections[this.sectionId]) return this.refreshCount();
      var doc = new DOMParser().parseFromString(sections[this.sectionId], 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      var current = $('[data-cart-drawer-inner]');
      if (fresh && current) {
        current.replaceWith(fresh);
        this.setCount(parseInt(fresh.getAttribute('data-cart-item-count'), 10) || 0);
      }
    },
    setCount: function (n) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
    },
    refreshCount: function () {
      return fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { Cart.setCount(c.item_count); });
    },
    add: function (formData) {
      var body = { items: [{ id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) }] };
      var props = {};
      formData.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = v; });
      if (Object.keys(props).length) body.items[0].properties = props;
      var sp = formData.get('selling_plan'); if (sp) body.items[0].selling_plan = sp;
      return this.request(theme.routes.cartAdd + '.js', body);
    },
    change: function (line, quantity) {
      return this.request(theme.routes.cartChange + '.js', { line: line, quantity: quantity });
    }
  };

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || theme.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart]');
    var text = form.querySelector('[data-add-to-cart-text]');
    var err = form.querySelector('[data-form-error]');
    var original = text ? text.textContent : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    if (text) text.textContent = theme.strings.adding;
    if (err) err.hidden = true;
    Cart.add(new FormData(form))
      .then(function (res) { Cart.render(res.sections); Overlay.open($('[data-cart-drawer]'), btn); })
      .catch(function (error) { if (err) { err.textContent = error.description || error.message || theme.strings.error; err.hidden = false; } })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        if (text) text.textContent = original;
      });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-change]');
    if (!b) return;
    e.preventDefault();
    Cart.change(Number(b.getAttribute('data-cart-change')), Number(b.getAttribute('data-quantity')))
      .then(function (res) { Cart.render(res.sections); var f = $('[data-cart-drawer] [data-drawer-close]'); if (f) f.focus(); })
      .catch(function () {});
  });

  document.addEventListener('change', debounce(function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    fetch(theme.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
  }, 300));

  /* ------------------------------------------------------------------
     Product page: variant picker, quantity, gallery
  ------------------------------------------------------------------ */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    var picker = section.querySelector('[data-variant-picker]');
    var form = section.querySelector('[data-product-form]');

    // Quantity
    $$('[data-quantity]', section).forEach(function (q) {
      var input = q.querySelector('input');
      if (!input) return;
      q.addEventListener('click', function (e) {
        if (e.target.closest('[data-qty-minus]')) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        if (e.target.closest('[data-qty-plus]')) input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });

    // Gallery counter (mobile swipe)
    var list = section.querySelector('[data-media-list]');
    var counter = section.querySelector('[data-media-current]');
    if (list && counter) {
      list.addEventListener('scroll', debounce(function () {
        counter.textContent = Math.round(list.scrollLeft / list.clientWidth) + 1;
      }, 60), { passive: true });
    }

    if (!jsonEl || !picker) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    function selected() {
      return $$('fieldset', picker).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function findVariant(opts) {
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function markAvailability(opts) {
      $$('fieldset', picker).forEach(function (fs, index) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[index] = input.value;
          var match = data.variants.filter(function (v) {
            return v.options.every(function (o, i) { return i > index ? true : o === test[i]; });
          });
          var available = match.some(function (v) { return v.available; });
          input.classList.toggle('is-unavailable', !available);
        });
      });
    }
    function scrollToMedia(id) {
      if (!id || !list) return;
      var item = list.querySelector('[data-media-id="' + id + '"]');
      if (!item) return;
      $$('.product__media-item', list).forEach(function (m) { m.classList.remove('is-active'); });
      item.classList.add('is-active');
      if (window.matchMedia('(max-width: 989px)').matches) {
        list.scrollTo({ left: item.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
      } else if (item !== list.firstElementChild) {
        list.insertBefore(item, list.firstElementChild);
      }
    }
    function update() {
      var opts = selected();
      $$('[data-option-selected]', picker).forEach(function (el, i) { el.textContent = (window.TIT_OPT_TX && window.TIT_OPT_TX[opts[i]]) || opts[i] || ''; });
      markAvailability(opts);
      var v = findVariant(opts);
      var btn = form && form.querySelector('[data-add-to-cart]');
      var btnText = form && form.querySelector('[data-add-to-cart-text]');
      if (!v) {
        if (btn) btn.disabled = true;
        if (btnText) btnText.textContent = theme.strings.unavailable;
        return;
      }
      var idInput = form && form.querySelector('[data-variant-id]');
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (btn) btn.disabled = !v.available;
      if (btnText) btnText.textContent = v.available ? theme.strings.addToCart : theme.strings.soldOut;
      var priceWrap = section.querySelector('[data-price]');
      if (priceWrap) {
        priceWrap.classList.toggle('price--on-sale', !!v.compare_at_price);
        priceWrap.innerHTML = '<span class="price__current">' + v.price + '</span>' + (v.compare_at_price ? '<s class="price__compare">' + v.compare_at_price + '</s>' : '');
      }
      var low = section.querySelector('[data-low-stock]');
      if (low) {
        var th = parseInt(low.getAttribute('data-threshold'), 10) || 0;
        var show = th > 0 && v.inventory !== null && v.inventory > 0 && v.inventory <= th;
        low.hidden = !show;
        if (show) low.querySelector('[data-low-stock-text]').textContent = low.getAttribute('data-template').replace('[count]', v.inventory);
      }
      var sp = section.querySelector('[data-sticky-price]'); if (sp) sp.textContent = v.price;
      var sv = section.querySelector('[data-sticky-variant]'); if (sv) sv.textContent = opts.map(function (o) { return (window.TIT_OPT_TX && window.TIT_OPT_TX[o]) || o; }).join(' / ');
      var sb = section.querySelector('[data-sticky-button]');
      if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? theme.strings.addToCart : theme.strings.soldOut; }
      scrollToMedia(v.featured_media);
      var url = section.getAttribute('data-product-url');
      if (url && window.history.replaceState) window.history.replaceState({}, '', url + '?variant=' + v.id);
    }
    picker.addEventListener('change', update);
    // Ensure every option group has a selection
    $$('fieldset', picker).forEach(function (fs) { if (!fs.querySelector('input:checked')) { var f = fs.querySelector('input'); if (f) f.checked = true; } });
    markAvailability(selected());
  }

  /* Dialogs (size guide) */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-dialog-open]');
    if (o) { var d = document.getElementById(o.getAttribute('data-dialog-open')); if (d && d.showModal) d.showModal(); return; }
    var c = e.target.closest('[data-dialog-close]');
    if (c) { var dlg = c.closest('dialog'); if (dlg) dlg.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* Share */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-share]');
    if (!b) return;
    var url = b.getAttribute('data-share-url');
    if (navigator.share) navigator.share({ title: b.getAttribute('data-share-title'), url: url }).catch(function () {});
    else if (navigator.clipboard) navigator.clipboard.writeText(url);
  });

  /* ------------------------------------------------------------------
     Product cards: swatch preview + wishlist heart
  ------------------------------------------------------------------ */
  document.addEventListener('mouseover', function (e) {
    var s = e.target.closest('[data-swatch-image]');
    if (!s) return;
    var card = s.closest('[data-product-card]');
    var img = card && card.querySelector('.product-card__image--primary');
    if (!img) return;
    img.srcset = s.getAttribute('data-swatch-srcset') || '';
    img.src = s.getAttribute('data-swatch-image');
    $$('.swatch', card).forEach(function (x) { x.classList.toggle('is-active', x === s); });
  });

  var WISH_KEY = 'tit-wishlist';
  function paintWishlist(root) {
    var list = storage(WISH_KEY) || [];
    $$('[data-wishlist]', root).forEach(function (b) { b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-wishlist')) > -1 ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist]');
    if (!b) return;
    e.preventDefault();
    var handle = b.getAttribute('data-wishlist');
    var list = storage(WISH_KEY) || [];
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    storage(WISH_KEY, list);
    paintWishlist(document);
  });

  /* ------------------------------------------------------------------
     Collection: sort autosubmit, facets autosubmit (desktop), load more
  ------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-facets-form]');
    if (!f) return;
    // Drop empty price inputs so URLs stay clean
    $$('input[type="number"]', f).forEach(function (i) { if (i.value === '') i.disabled = true; });
  });
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-load-more]');
    if (!more) return;
    e.preventDefault();
    more.setAttribute('aria-busy', 'true');
    fetch(more.href).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = $('[data-product-grid]');
      var newItems = $$('[data-product-grid] > li', doc);
      newItems.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
      var nextWrap = doc.querySelector('[data-load-more-wrap]');
      var wrap = $('[data-load-more-wrap]');
      if (wrap && nextWrap) wrap.replaceWith(document.importNode(nextWrap, true));
      else if (wrap) wrap.remove();
      if (window.history.replaceState) window.history.replaceState({}, '', more.href);
      paintWishlist(grid);
    }).catch(function () { window.location.href = more.href; });
  });

  /* ------------------------------------------------------------------
     Predictive search
  ------------------------------------------------------------------ */
  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', class extends HTMLElement {
      connectedCallback() {
        if (this.getAttribute('data-enabled') !== 'true') return;
        this.input = this.querySelector('[data-predictive-input]');
        this.results = this.querySelector('[data-predictive-results]');
        if (!this.input) return;
        this.controller = null;
        this.input.addEventListener('input', debounce(this.search.bind(this), 250));
      }
      search() {
        var q = this.input.value.trim();
        if (q.length < 2) { this.results.innerHTML = ''; return; }
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        var url = theme.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,vendor,tag';
        fetch(url, { signal: this.controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive-inner]');
            this.results.innerHTML = inner ? inner.outerHTML : '';
          }.bind(this))
          .catch(function () {});
      }
    });
  }

  /* ------------------------------------------------------------------
     Product recommendations
  ------------------------------------------------------------------ */
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.children.length) return;
        var load = function () {
          fetch(this.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var el = doc.querySelector('product-recommendations');
            if (el && el.innerHTML.trim()) { this.innerHTML = el.innerHTML; paintWishlist(this); }
          }.bind(this)).catch(function () {});
        }.bind(this);
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) { io.disconnect(); load(); }
          }, { rootMargin: '0px 0px 400px 0px' });
          io.observe(this);
        } else load();
      }
    });
  }

  /* ------------------------------------------------------------------
     Reveal on scroll
  ------------------------------------------------------------------ */
  var revealObserver = null;
  function initReveal(root) {
    var items = $$('.reveal:not(.is-visible)', root);
    if (!document.documentElement.classList.contains('reveal-on') || reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); revealObserver.unobserve(en.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    items.forEach(function (el) { revealObserver.observe(el); });
  }

  /* Login: toggle recover password */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle-recover]');
    if (!t) return;
    e.preventDefault();
    var r = $('#RecoverPassword'), l = $('#CustomerLogin');
    if (r && l) { r.hidden = !r.hidden; l.hidden = !l.hidden; }
  });

  /* Hero parallax (subtle) */
  var parallax = $('[data-parallax]');
  if (parallax && !reducedMotion) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, window.innerHeight);
        parallax.style.transform = 'translate3d(0,' + (y * 0.22) + 'px,0)';
        ticking = false;
      });
    }, { passive: true });
  }

  /* ------------------------------------------------------------------
     Init + Theme Editor support
  ------------------------------------------------------------------ */
  /* Sticky add-to-cart bar */
  function initSticky(root) {
    var bar = $('[data-sticky-atc]', root);
    var main = $('[data-product-section] [data-add-to-cart]', root);
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var footer = $('.site-footer');
    var mainVisible = true, footerVisible = false;
    function paint() {
      var on = !mainVisible && !footerVisible && main.getBoundingClientRect().top < 0;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var btn = bar.querySelector('[data-sticky-button]'); if (btn) btn.tabIndex = on ? 0 : -1;
    }
    new IntersectionObserver(function (e) { mainVisible = e[0].isIntersecting; paint(); }).observe(main);
    if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; paint(); }).observe(footer);
  }

  /* Delivery estimate (business days) + real dispatch cutoff countdown */
  function initDelivery(root) {
    $$('[data-delivery]', root).forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 3;
      var max = parseInt(el.getAttribute('data-max'), 10) || 6;
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 0;
      var loc = el.getAttribute('data-locale') || 'en';
      var now = new Date();
      var start = new Date(now);
      if (cutoff && now.getHours() >= cutoff) start.setDate(start.getDate() + 1);
      function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6 !== 0) n--; } return x; }
      var fmt = new Intl.DateTimeFormat(loc, { weekday: 'short', day: 'numeric', month: 'short' });
      var range = el.querySelector('[data-delivery-range]');
      if (range) range.textContent = fmt.format(addBiz(start, min)) + ' – ' + fmt.format(addBiz(start, max));
      var cut = el.querySelector('[data-delivery-cutoff]');
      var biz = now.getDay() % 6 !== 0;
      if (cut && cutoff && biz && now.getHours() < cutoff) {
        var tick = function () {
          var n = new Date(), end = new Date(n); end.setHours(cutoff, 0, 0, 0);
          var ms = end - n; if (ms <= 0) { cut.hidden = true; return; }
          var h = Math.floor(ms / 3600000), m = Math.floor(ms / 60000) % 60;
          cut.textContent = (theme.strings.cutoff || '').replace('%TIME%', h + 'h ' + m + 'min');
          cut.hidden = false;
        };
        tick(); setInterval(tick, 30000);
      }
    });
  }

  function init(root) {
    $$('[data-product-section]', root).forEach(initProduct);
    initSticky(root);
    initDelivery(root);
    initReveal(root);
    paintWishlist(root);
  }
  if (window.location.hash === '#recover') { var r = $('#RecoverPassword'), l = $('#CustomerLogin'); if (r && l) { r.hidden = false; l.hidden = true; } }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () { if (Overlay.active) Overlay.close(true); });
})();

/* Community banner: gentle zoom-in when visible */
(function () {
  var els = document.querySelectorAll('[data-community]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.2 });
  els.forEach(function (el) { io.observe(el); });
})();
